module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/点赞.e947e.png";